import React, { useState } from 'react';
import {useSiteContent} from '../../context/SiteContentContext';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';

function OffCanvasStyleOne() {
  const [show, setShow] = useState(false);
  const {content,contact}=useSiteContent();const footer=content.footer;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
        <div className="side-content-button">
            <Link to="#" variant="primary" className="navSidebar-button" onClick={handleShow}>
                <span className="decor"></span>
                <span className="decor"></span>
                <span className="decor"></span>
            </Link>

            <Offcanvas show={show} onHide={handleClose} className="xs-sidebar-group info-group info-sidebar isActive">
                <div className="xs-overlay xs-bg-black"></div>
                    <div className="xs-sidebar-widget">
                        <div className="sidebar-widget-container">
                            <Offcanvas.Header closeButton className="close-side-widget">
                            </Offcanvas.Header>
                            <div className="sidebar-textwidget">
                                <div className="sidebar-info-contents">
                                    <div className="content-inner">
                                        <div className="logo">
                                            <Link to="/" style={{ display: 'inline-flex', alignItems: 'flex-start' }}>
                                                <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/resources/stricky-logo.png`}
                                                    alt="SKV Industries"
                                                    style={{ width: 'min(220px, 100%)', maxHeight: '180px', height: 'auto', objectFit: 'contain', display: 'block' }}
                                                />
                                            </Link>
                                        </div>
                                        <div className="content-box">
                                            <h4>About Us</h4>
                                            <div className="inner-text">
                                                <p>{footer?.sidebarDescription}</p>
                                            </div>
                                        </div>
                                        <div className="sidebar-contact-info">
                                            <h4>Contact Info</h4>
                                            <ul>
                                                <li>
                                                    <span className=" icon-maps-and-flags "></span>{contact?.address}
                                                </li>
                                                <li>
                                                    <span className="icon-phone-call-1"></span>
                                                    <a href={"tel:"+(contact?.phone || "")}>{contact?.phone}</a>
                                                </li>
                                                <li>
                                                    <span className="icon-email-1"></span>
                                                    <a href={"mailto:"+(contact?.email || "")}>{contact?.email}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="thm-social-link1">
                                            <ul className="social-box">
                                                <li className="facebook">
                                                    <a aria-label="Facebook" href={footer?.facebook}><i className="icon-facebook-app-symbol" aria-hidden="true"></i></a>
                                                </li>
                                                <li className="instagram">
                                                    <a aria-label="Instagram" href={footer?.instagram}><i className="fa-brands fa-instagram" aria-hidden="true"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Offcanvas>
        </div>
    </>
  );
}

export default OffCanvasStyleOne;
